function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.09528 6.40394L4.68971 7.99767C4.23221 8.51642 3.65943 8.79737 2.97135 8.84054C2.28327 8.88371 1.67986 8.67654 1.16112 8.21904C0.642371 7.76154 0.361415 7.18875 0.318247 6.50068C0.27508 5.8126 0.482246 5.20919 0.939746 4.69045L2.34532 3.09671L2.90781 3.59279L1.50224 5.18653C1.18254 5.54903 1.03782 5.9714 1.06807 6.45364C1.09833 6.93588 1.2947 7.33685 1.6572 7.65655C2.0197 7.97625 2.44207 8.12097 2.92431 8.09071C3.40655 8.06046 3.80752 7.86408 4.12722 7.50159L5.53279 5.90785L6.09528 6.40394ZM3.46804 6.17023L2.90554 5.67415L5.46864 2.76792L6.03114 3.264L3.46804 6.17023ZM6.59137 5.84144L6.02887 5.34536L7.43444 3.75162C7.75414 3.38912 7.89887 2.96675 7.86861 2.48451C7.83836 2.00227 7.64198 1.6013 7.27948 1.2816C6.91699 0.961904 6.49462 0.817181 6.01238 0.847435C5.53014 0.877689 5.12916 1.07407 4.80947 1.43656L3.4039 3.0303L2.8414 2.53421L4.24697 0.940478C4.70447 0.421732 5.27726 0.140776 5.96534 0.0976083C6.65341 0.0544408 7.25682 0.261607 7.77557 0.719107C8.29431 1.17661 8.57527 1.74939 8.61844 2.43747C8.66161 3.12555 8.45444 3.72896 7.99694 4.2477L6.59137 5.84144Z",
  fill: "#707070"
});
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.56ebaf629eb31028c753a1cd570f5731.svg";
export { ForwardRef as ReactComponent };